var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrowser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3.75C0 2.7835 0.783501 2 1.75 2H22.25C23.2165 2 24 2.7835 24 3.75V20.25C24 21.2165 23.2165 22 22.25 22H1.75C0.783502 22 0 21.2165 0 20.25V3.75ZM1.75 3.5C1.61193 3.5 1.5 3.61193 1.5 3.75V5.5H5.5V3.5H1.75ZM7 3.5V5.5H11V3.5H7ZM12.5 3.5V5.5H22.5V3.75C22.5 3.61193 22.3881 3.5 22.25 3.5H12.5ZM22.5 7H1.5V20.25C1.5 20.3881 1.61193 20.5 1.75 20.5H22.25C22.3881 20.5 22.5 20.3881 22.5 20.25V7Z",
    fill: "#111111"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowser);
export default __webpack_public_path__ + "static/media/browser.19c0af69.svg";
export { ForwardRef as ReactComponent };